import { render } from "./CrawlBookDialog.vue?vue&type=template&id=ab4541dc&scoped=true&ts=true"
import script from "./CrawlBookDialog.vue?vue&type=script&lang=ts"
export * from "./CrawlBookDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab4541dc"]])

export default __exports__